<template>
  <graph-detail08-template
    :board-ids="[242]"
    field-code="facility-public"
    :com-group-list="comGroupList"
    graph1-title="전체 (공중(다중)이용시설) 비상조치계획수립 현황"
    graph2-title="월별 (공중(다중)이용시설) 비상조치계획수립 현황"
    graph3-title="기간별 (공중(다중)이용시설) 비상조치계획수립 현황"
    field-label="공중(다중)이용시설"
    field-category-label="구분"
  />
</template>

<script>
/* eslint-disable brace-style */
import GraphDetail08Template from "@/views/graph-detail/GraphDetail08Template.vue";

export default {
  name: "GraphDetail63",
  components: {
    GraphDetail08Template,
  },
  props: {
    comGroupList: Object,
  },
};
</script>

<style scoped></style>
